import { Link } from "react-router-dom";
import { genres, siteInfo } from "@/mocks/dramas";
import type { Drama } from "@/mocks/dramas";

export default function RankingSidebar({ picks }: { picks: Drama[] }) {
  return (
    <aside className="space-y-6 lg:sticky lg:top-28">
      <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-bookmark-3-line text-accent-400" aria-hidden="true"></i>
          编辑推荐
        </h2>
        <ul className="mt-4 space-y-4">
          {picks.map((drama, index) => (
            <li key={drama.id} className="flex items-center gap-3">
              <span className="font-heading text-lg font-bold text-primary-400">
                {String(index + 1).padStart(2, "0")}
              </span>
              <Link
                to={`/drama/${drama.id}`}
                className="min-w-0 flex-1 cursor-pointer"
              >
                <span className="block truncate text-sm font-label text-foreground-900 transition-colors hover:text-primary-400">
                  {drama.title}
                </span>
                <span className="block text-[11px] text-foreground-500">
                  {drama.category} · {drama.rating.toFixed(1)} 分
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="rounded-lg border border-background-200/70 bg-background-100/60 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-apps-2-line text-accent-400" aria-hidden="true"></i>
          口味直达
        </h2>
        <div className="mt-4 flex flex-wrap gap-2">
          {genres.map((genre) => (
            <Link
              key={genre.slug}
              to={`/ranking?category=${genre.slug}`}
              className="whitespace-nowrap rounded-full border border-background-300/60 px-3 py-1.5 text-xs font-label text-foreground-700 transition-colors hover:border-accent-500/70 hover:text-accent-400 cursor-pointer"
            >
              {genre.name}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-accent-500/30 bg-accent-100/20 p-5">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-error-warning-line text-accent-400" aria-hidden="true"></i>
          榜单说明
        </h2>
        <p className="mt-3 text-xs leading-relaxed text-foreground-700">
          热度榜与口碑榜每日 10:00 更新，新剧会在上线后 24 小时内补录。评分由编辑团队按剧情完成度、节奏与制作水准统一评定。
        </p>
        <p className="mt-3 flex items-center gap-2 text-xs font-label text-foreground-500">
          <i className="ri-refresh-line text-accent-400" aria-hidden="true"></i>
          {siteInfo.updateNote}
        </p>
      </div>
    </aside>
  );
}